import React from 'react';
import SectionTitle from './SectionTitle';
import logoWillBJ from '../assets/img/webp/logo-willbj.webp';
import logoEDSB from '../assets/img/webp/logoEDSB.webp';

function Partenaires() {
  return (
    <div className="section section--seam section--blue-dark partenaires">
      <SectionTitle overline="Ils nous soutiennent">Nos partenaires</SectionTitle>
      <div className='container-partenaires'>
        <a href="https://djwillbj.com" target="_blank" rel="noopener noreferrer">
          <img src={logoWillBJ} alt="WILL-BJ" width="200" height="120" decoding="async" loading="lazy" />
        </a>
        <a href="https://www.edsb.fr/" target="_blank" rel="noopener noreferrer">
          <img src={logoEDSB} alt="EDSB" width="200" height="120" decoding="async" loading="lazy" />
        </a>
      </div>
    </div>
  );
}

export default Partenaires;
